module.exports = __webpack_public_path__ + "static/mentor-5dd0b35018d1220011f160ec7497bf52.png";